import * as types from "./mutation_types"

export default {
    [types.RESET](state) {
        Object.assign(state, {
            isLoading: false,
            item: null,
            isUpdated: false,
            showUser: false,
            user: "",
            isSuccess: false,
       
        })
    },
    [types.SET_TOGGLE_LOADING](state) {
        Object.assign(state, { isLoading: !state.isLoading })
    },
    [types.SET_SHOW_LOADING](state) {
        Object.assign(state, { isLoading: true })
    },
    
    [types.SET_HIDE_LOADING](state) {
        Object.assign(state, { isLoading: false })
    },
    [types.SET_TOGGLE_USER](state) {
        Object.assign(state, { showUser: !state.showUser })
    },
    [types.SET_SHOW_USER](state) {
        Object.assign(state, { showUser: true })
    },
    [types.SET_HIDE_USER](state) {
        Object.assign(state, { showUser: false })
    },
   
    [types.SET_IS_SUCCESS](state) {
        Object.assign(state, { isSuccess: true })
    },
    [types.SET_IS_ERROR](state) {
        Object.assign(state, { isSuccess: false })
    },
    [types.SET_USER](state, user) {
        Object.assign(state, { user })
    },
    [types.SET_ITEMS](state, item) {
        Object.assign(state, { item })
    },



}